import * as React from "react"

export const ThemeContext = React.createContext(null);

const Theme = ({
  value,
  children
}) => {
  return (
    <ThemeContext.Provider
      value={value}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export default Theme
